import React from 'react'
import {
  DialogContent,
  DialogContentProps,
} from 'components/Dialog'
import { useViewport } from 'hooks'

export type FiltersDialogContentProps = DialogContentProps

export const FiltersDialogContent: React.FC<FiltersDialogContentProps> = (props) => {
  const { isMedium } = useViewport()

  return <DialogContent {...props as DialogContentProps} sx={[
    (theme) => ({
      p: isMedium ? `${theme.spacing(3)} !important` : `${theme.spacing(3)} !important`,
    }),
    ...(Array.isArray(props.sx) ? props.sx : [props.sx])
  ]} />
}

export default FiltersDialogContent
